import { useState, useEffect } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { C, ACTIONS, ago } from "./hubShared";

const waNumber = (cell) => {
  const d = String(cell || "").replace(/\D/g, "");
  return d.startsWith("0") ? `27${d.slice(1)}` : d;
};

export const HubActionDialog = ({ member, onClose, onDone }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setEmail(member?.email || ""); }, [member]);
  if (!member) return null;
  const a = ACTIONS[member.next_action];
  const recent = member.days_since_mail != null && member.days_since_mail < 3;

  const run = async () => {
    setBusy(true);
    try {
      if (member.next_action === "whatsapp") {
        const { data } = await api.post(`/contacts/${member.id}/invite`);
        const first = (member.full_name || "").split(" ")[0] || "there";
        const msg = `Hi ${first}, your ResQ1 emergency cover is ready. Tap to install the app and set your password: ${data.link}`;
        window.open(`https://wa.me/${waNumber(member.cell)}?text=${encodeURIComponent(msg)}`, "_blank");
        toast.success("WhatsApp opened with their invite link");
      } else {
        const body = member.next_action === "debit_order" ? { send_invite: false }
          : member.next_action === "fix_email" ? { email } : {};
        const { data } = await api.post(`/contacts/${member.id}/welcome-pack`, body);
        const ok = ["sent", "simulated"].includes(data.email_status);
        ok ? toast.success(`Emailed ${data.email}`) : toast.error(`Not sent: ${data.email_status || "no email on file"}`);
      }
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Action failed"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="hub-action-dialog" style={{ background: C.body }}>
        <DialogHeader>
          <DialogTitle>{a.label} — {member.full_name}</DialogTitle>
          <DialogDescription>This will {a.verb}.</DialogDescription>
        </DialogHeader>
        <div style={{ fontSize: 13, color: C.ink, lineHeight: 1.6 }}>
          <div data-testid="hub-action-last-mailed" style={{ padding: "10px 12px", borderRadius: 8, background: recent ? `${C.amber}22` : "#fff", border: `1px solid ${recent ? C.amber : "rgba(26,30,36,0.10)"}` }}>
            Last mailed <b>{ago(member.days_since_mail)}</b>{member.last_campaign ? ` · ${member.last_campaign}` : ""} · mailed <b>{member.times_mailed}</b> time{member.times_mailed === 1 ? "" : "s"} so far
            {recent && <div style={{ color: "#8A5A0B", fontWeight: 600, marginTop: 4 }}>They were mailed very recently — are you sure?</div>}
          </div>
          {member.next_action === "fix_email" && (
            <label style={{ display: "block", marginTop: 12 }}>
              <span style={{ fontSize: 12, color: C.slate }}>Correct email address</span>
              <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="hub-action-email-input" type="email"
                style={{ display: "block", width: "100%", marginTop: 4, padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(26,30,36,0.2)", background: "#fff" }} />
            </label>
          )}
          {member.next_action === "whatsapp" && !member.cell && <div style={{ color: C.red, marginTop: 10 }}>No cell number on file.</div>}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
          <button onClick={onClose} data-testid="hub-action-cancel" className="hub-btn" style={{ background: "#fff", color: C.ink, border: "1px solid rgba(26,30,36,0.15)" }}>Cancel</button>
          <button onClick={run} disabled={busy || (member.next_action === "fix_email" && !email.includes("@")) || (member.next_action === "whatsapp" && !member.cell)}
            data-testid="hub-action-confirm" className="hub-btn" style={{ background: C.red, color: "#fff", border: 0 }}>
            {busy ? "Working…" : `Yes, ${a.confirm}`}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
